<section class="row clearfix" *ngIf="editable || data.enable" [class.odd]="data.index % 2  == 0">
  <div class="col-md-12" *ngIf="editable">
    <app-index-controller [data]="data" [canToggleWow]="false"></app-index-controller>
  </div>
  
  <div class="act">
    <div class="col-lg-10 offset-lg-1 col-md-12">
      <app-banner02 [bannerMeta]="remoteData" [nav]="false"></app-banner02>
    </div>
  </div>
</section>